<!-- This file is not localized on purpose as it's a DE-only integration -->
<form [formGroup]="group()" layout-vertical>
  <div layout-horizontal margin-bottom>
    <rt-form-field margin-right class="compensation-profile-form-field">
      <rt-label> Vergütung </rt-label>
      <rt-select
        formControlName="compensationProfile"
        [options]="compensationProfileOptions()"
        [includeEmptyOption]="false"
      />
    </rt-form-field>
  </div>
  @if (compensationTypeRequired()) {
    <div layout-horizontal margin-bottom>
      <rt-form-field margin-right class="compensation-type-form-field">
        <rt-label> Angabe der Vergütung </rt-label>
        <rt-select
          formControlName="compensationType"
          [options]="COMPENSATION_TYPE_OPTIONS"
          [includeEmptyOption]="false"
        />
      </rt-form-field>
    </div>
  }
  @if (fixedSalaryRequired()) {
    <div layout-horizontal margin-bottom>
      <rt-form-field margin-right class="fixed-salary-form-field">
        <rt-label>Jahresgehalt</rt-label>
        <rt-input variant="rounded" formControlName="fixedSalary" />
      </rt-form-field>
    </div>
  }
  @if (salaryRangeRequired()) {
    <div layout-horizontal margin-bottom>
      <rt-form-field margin-right class="salary-range-from-form-field">
        <rt-label>Jahresgehalt von</rt-label>
        <rt-input variant="rounded" formControlName="salaryRangeFrom" />
      </rt-form-field>
      <rt-form-field margin-right class="salary-range-to-form-field">
        <rt-label>Jahresgehalt bis</rt-label>
        <rt-input variant="rounded" formControlName="salaryRangeTo" />
      </rt-form-field>
    </div>
    @if (salaryRangeError()) {
      <div layout-horizontal margin-bottom>
        <div class="salary-range-error">
          "Jahresgehalt von“ nicht größer sein als der Wert "Jahresgehalt bis“
        </div>
      </div>
    }
  }
  @if (apprenticePayRequired()) {
    <div layout-horizontal margin-bottom>
      <rt-form-field margin-right class="apprentice-pay-year-form-field">
        <rt-label>1. Ausbildungsjahr</rt-label>
        <rt-input variant="rounded" formControlName="year1" />
      </rt-form-field>
      <rt-form-field margin-right class="apprentice-pay-year-form-field">
        <rt-label>2. Ausbildungsjahr</rt-label>
        <rt-input variant="rounded" formControlName="year2" />
      </rt-form-field>
      <rt-form-field margin-right class="apprentice-pay-year-form-field">
        <rt-label>3. Ausbildungsjahr</rt-label>
        <rt-input variant="rounded" formControlName="year3" />
      </rt-form-field>
      <rt-form-field margin-right class="apprentice-pay-year-form-field">
        <rt-label>4. Ausbildungsjahr</rt-label>
        <rt-input variant="rounded" formControlName="year4" />
      </rt-form-field>
    </div>
  }
</form>
